<!-- Component Container -->
<div class="full-contractor-container">

  <!-- Projects the content or component base on the route -->
  <router-outlet></router-outlet>

  <!-- Blue Footer -->
  <footer></footer>
</div>
